import CallStore from './CallStore';
import ChatsStore from './ChatsStore';
import ClidStore from './ClidStore';
import DialerStore from './DialerStore';
import SettingsStore from './SettingsStore';
import TranscriptStore from './TranscriptStore';

export class RootStore {
  public chatsStore: ChatsStore;
  public settingsStore: SettingsStore;
  public dialerStore: DialerStore;
  public transcriptStore: TranscriptStore;
  public callStore: CallStore;
  public clidStore: ClidStore;

  constructor() {
    this.chatsStore = new ChatsStore(this);
    this.settingsStore = new SettingsStore(this);
    this.dialerStore = new DialerStore(this);
    this.transcriptStore = new TranscriptStore(this);
    this.callStore = new CallStore(this);
    this.clidStore = new ClidStore(this);
  }
}
